<template>
  <div class="main col-xs-12">
    <AppMessages v-bind:message="this.message"
                 v-bind:type="this.messageType"
                 v-bind:show="this.show" />

    <h1>Product Batch Entry</h1>
    <AppProductSearch ref="child" v-bind:enabled="this.selectProductEnabled" />

    <form>

      <div class="form-group row" v-show="product">
        <selectize :disabled="!this.selectProductEnabled" v-model="batch" :settings="batchSelectListSettings">
          <option value="_manual_">Manual</option>
          <option :value="batchstatus.batchNumber" v-bind:key="batchstatus.batchNumber" v-for="batchstatus in batchesstatus">{{ batchstatus.name }}</option>
        </selectize>
        <div>
          <span class="loader" v-show="!selectProductEnabled"></span>
        </div>

        <div v-show="manualbatch" class="form-inline">
          <label class="label">Batch No:</label>
          <input class="input" v-model="manualbatchno" v-bind:class="{'form-group--error':manualBatchError.msg}" />
          <span v-if="manualBatchError.msg" class="error">{{ manualBatchError.msg }}</span>
        </div>
      </div>
    </form>

    <template v-if="results.length > 0">
      <form>
        <div class="form-group">
          <label class="label">PO No:</label>
          <input class="input" v-model="ponumber" v-bind:class="{'form-group--error':poError.msg}" />
          <span v-if="poError.msg" class="error">{{ poError.msg }}</span>
        </div>
        <div class="form-group">
          <button class="button button--alt button--clear"
                  type="button"
                  v-on:click="editResults()">
            Edit Results
          </button>
        </div>

        <table v-if="results" class="table">
          <thead>
            <tr>
              <th class="table__header">Company</th>
              <th class="table__header">Product</th>
              <th class="table__header">No</th>
              <th class="table__header">Type</th>
              <th class="table__header">Description</th>
              <th class="table__header">Lower</th>
              <th class="table__header">Upper</th>
              <th class="table__header">Answer</th>
            </tr>
          </thead>
          <tbody>
            <tr v-bind:key="result.product" v-for="result in results">
              <td class="table__col">{{ result.company }}</td>
              <td class="table__col">{{ product.code }}</td>
              <td class="table__col">{{ result.parameterNo }}</td>
              <td class="table__col">{{ result.type }}</td>
              <td class="table__col">{{ result.description }}</td>
              <td class="table__col">{{ result.lower }}</td>
              <td class="table__col">{{ result.upper }}</td>
              <td class="table__col">
                <div v-if="resultsedit">
                  <input v-if="result.type !== 'CoO'" class="input form-block" v-model="result.answer" v-bind:class="{'form-group--error':result.error}" />
                  <multiselect v-if="result.type === 'CoO'"
                    v-model="selected"
                    :options="options"
                    :multiple="true"
                  >
                  </multiselect>
                  <div v-if="result.error" class="error">{{ result.error.msg }}</div>
                </div>
                <div v-else>
                  <div v-show="result.answer && result.type !== 'CoO'" v-bind:class="{'form-group--error':result.error}">{{ result.answer }}</div>
                  <div v-if="result.error" class="error">{{ result.error.msg }}</div>
                  <multiselect disabled="disabled" v-if="result.type === 'CoO'"
                               v-model="selected"
                               :options="options"
                               :multiple="true"
                  >
                  </multiselect>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </form>

      <form class="noborder">
        <div>
          <div class="input__file">
            <button class="button">Choose file</button>
            <input type="file" name="fileupload" ref="fileupload" @change="onFileSelected" />
            <label class="label label--alt" for="fileupload" style="width: 200px;">
              <span v-if="fileupload">{{ fileupload.name }}</span>
              <span v-else>Choose a file</span>
            </label>
          </div>
          <input id="file-check" v-model="isprivatefile" class="checkbox" type="checkbox" />
          <label for="file-check" v-show="fileupload" class="label label--alt-inline">Not sent to customer</label>
          <button class="button button--alt" v-on:click="uploadFile" v-show="fileupload" type="button">Upload</button>

          <div class="form-group">
            <div v-if="genericErrors.length > 0">
              <div>Please correct the following generic errors</div>
              <ul class="form-group--error">
                <li v-for="error in genericErrors" class="error">
                  {{ error }}
                </li>
              </ul>
            </div>
            <p class="seperator">
              <button class="button button--alt" type="button" v-on:click="saveAsDraft">Save as draft</button>
              <button class="button button--alt" type="button" v-on:click="saveAsCompleted">Save as completed</button>
            </p>
          </div>
        </div>

        <h2>Attached Files</h2>
        <ul v-if="internalAttachments.length > 0 || externalAttachments.length > 0">
          <li v-bind:key="getUniqueKey('inf', index)" v-for="(attachment, index) in externalAttachments">
            <a v-bind:href="attachment.url">{{ attachment.fileName }}</a>
          </li>
          <li v-bind:key="getUniqueKey('exf', index)" v-for="(attachment, index) in internalAttachments">
            <a v-bind:href="attachment.url">{{ attachment.fileName }} (not sent to customer)</a>
          </li>
        </ul>
        <p v-else>None</p>
      </form>
    </template>
  </div>
</template>

<script>
  import Selectize from 'vue2-selectize';
  import axios from 'axios';
  import Multiselect from 'vue-multiselect'
  import AppMessages from '@/components/AppMessages/AppMessages.vue';
  import AppProductSearch from '@/components/AppProductSearch/AppProductSearch.vue';
  import Validation from '../validation'
  import SelectPopulate from '../mixins/SelectPopulate';
  import SearchObjects from '../mixins/SearchObjects';

  export default {
    name: 'batchentry',
    components: {
      Selectize,
      AppMessages,
      AppProductSearch,
      Multiselect
    },
    mixins: [SelectPopulate, SearchObjects],
    data() {
      return {
        productSelectListSettings: {
          maxOptions: 10000,
          sortField: [{ field: 'value', direction: 'asc' }, { field: '$score' }],
          allowEmptyOption: false,
          placeholder: 'Select value'
        },

        batchSelectListSettings: {
          sortField: [{ field: '$order' }, { field: 'value', direction: 'asc' }, { field: '$score' }],
          allowEmptyOption: false,
          placeholder: 'Select value'
        },

        selected: null,
        options: [],

        // products: null,
        batchesstatus: [],
        product: null,
        batch: null,
        manualbatch: false,
        manualbatchno: null,
        ponumber: null,
        results: [],
        itemx: '',
        cert: '',
        resultsedit: false,
        internalAttachments: [],
        externalAttachments: [],
        isprivatefile: false,
        fileupload: null,
        message: null,
        messageType: null,
        show: null,
        poError: [],
        manualBatchError: [],
        genericErrors: [],
        selectProductEnabled: true
      };
    },
    mounted() {
      this.$watch(
        '$refs.child.selectedProduct',
        (newValue, oldValue) => (this.product = newValue)
      );
    },
    watch: {
      product(value) {

        this.cert = null;
        this.batch = null;
        this.manualbatch = false;
        this.manualbatchno = null;
        this.resetErrors(true, true, true);
        this.resultsedit = false;
        if (!value) {
          this.batchesstatus = [];
          return;
        }

        this.cert = `${value.certType} | ${value.description}`;

        this.loadBatches();
      },
      batch(value) {
        this.results = [];
        this.manualbatch = value === '_manual_';
        this.manualbatchno = null;
        this.resetErrors(true, true, true);
        this.resultsedit = false;

        if (!value) {
          this.results = [];
          return;
        }

        let batchno = this.getBatchNo();

        if (batchno != null) {
          batchno = encodeURIComponent(batchno);
        }

        const draftresults = axios.get(`/products/${this.product.code}/draft-batch-results/${batchno}`);
        const draftfiles = axios.get(`/products/${this.product.code}/batches/${batchno}/files`);

        const $scope = this;

        this.$Progress.start();

        axios
          .all([draftresults, draftfiles])
          .then(axios.spread((r, f) => {
            const data = r.data[0];
            $scope.ponumber = data.poNumber;
            const tempResults = [];

            for (let i = 0; i < data.results.length; i++) {
              const item = data.results[i];

              tempResults.push({
                parameterNo: item.parameterNo,
                description: item.description,
                lower: item.lowerLimit,
                upper: item.upperLimit,
                answer: item.result,
                type: item.type,
                company: item.company,
                error: null,
              });

              if (item.type === 'CoO' && item.result !== '') {
                $scope.selected = JSON.parse(item.result);
              }

            }

            $scope.results = tempResults;

            $scope.internalAttachments = f.data.internalFiles;
            $scope.externalAttachments = f.data.externalFiles;

            $scope.$Progress.finish();
          }))
          .catch(() => {
            this.$Progress.fail();
            this.message = 'Results not loaded';
            this.messageType = 'message message--error';
            this.show = true;
          });
      },
    },
    methods: {
      customLabel(option) {
        return `${option.label} (Value: ${option.value})`;
      },
      resetErrors(clearPoError, clearManualBatchError, clearGenericError) {
        if (clearPoError) {
          this.poError = [];
        }

        if (clearManualBatchError) {
          this.manualBatchError = [];
        }

        if (clearGenericError) {
          this.genericErrors = [];
        }
      },
      editResults() {
        this.resultsedit = true;

        const options = this.options;
        axios
          .post('/get-country-list')
          .then((r) => {

            Object.keys(r.data).forEach(key => {
              options.push(r.data[key].name.common)
            });

            this.options = options;
          })
          .catch((e) => {
          })
      },
      uploadFile() {
        const formData = new FormData();
        formData.append('File', this.fileupload);

        let batchno = this.getBatchNo();

        if (batchno != null) {
          batchno = encodeURIComponent(batchno);
        }

        const url = this.isprivatefile
          ? `/products/${this.product.code}/batches/${batchno}/private-files`
          : `/products/${this.product.code}/batches/${batchno}/files`;

        const config = {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        };

        axios
          .post(url, formData, config)
          .then((r) => {
            this.message = 'File uploaded';
            this.messageType = 'message message--success';
            this.show = true;
            this.fileupload = null;

            this.loadFiles();
          })
          .catch((e) => {
            this.message = `File not uploaded: ${e.response.data.join(', ')}`;
            this.messageType = 'message message--error';
            this.show = true;
            this.$Progress.fail();
          })
          .finally(() => {
            this.$Progress.finish();
          });
      },
      onFileSelected() {
        this.fileupload = this.$refs.fileupload.files[0];
      },
      saveAsCompleted() {
        const $scope = this;
        const batchresults = [];

        for (let i = 0; i < this.results.length; i += 1) {
          const item = this.results[i];

          if (item.type === 'CoO') {
            item.answer = JSON.stringify(this.selected);
          }

          batchresults.push({
            id: item.parameterNo,
            type: item.type,
            description: item.description,
            upperLimit: item.upper,
            lowerLimit: item.lower,
            result: item.answer || '',
          });
        }

        const data = {
          batchNumber: this.getBatchNo(),
          poNumber: this.ponumber,
          batchType: !this.manualbatch ? 'R' : 'M',
          results: batchresults,
        };


        $scope.results.forEach((r) => { r.error = null; });
        this.resetErrors(true, true, true);
        this.show = false;

        axios
          .post(`/products/${this.product.code}/batch-results`, data)
          .then((r) => {
            this.message = 'Batch saved';
            this.messageType = 'message message--success';
            this.show = true;
            this.batch = null;

            this.$Progress.finish();

            this.resultsedit = false;
          })
          .catch((e) => {
            this.$Progress.fail();

            if (e.response.data != undefined) {

              // temp array of { field, msg } values
              var batchErrors = [];

              Validation.parseServerErrors(e.response.data, batchErrors, $scope.genericErrors);
              Validation.updateErrorMessages(batchErrors, $scope.results, $scope.poError, $scope.manualBatchError);

              this.message = 'Unable to save batch records. Please correct validation errors before continuing';
              this.messageType = 'message message--error';
              this.show = true;
            }
          });
      },
      saveAsDraft() {
        const batchresults = [];

        const $scope = this;

        for (let i = 0; i < this.results.length; i++) {
          const item = this.results[i];

          if (item.type === 'CoO') {
            item.answer = JSON.stringify(this.selected);
          }


          batchresults.push({
            id: item.parameterNo,
            type: item.type,
            description: item.description,
            upperLimit: item.upper,
            lowerLimit: item.lower,
            result: item.answer || '',
          });
        }

        const data = {
          batchNumber: this.getBatchNo(),
          poNumber: this.ponumber,
          batchType: !this.manualbatch ? 'R' : 'M',
          results: batchresults,
        };

        $scope.results.forEach((r) => { r.error = null; });
        $scope.poError = [];
        $scope.manualBatchError = [];
        $scope.genericErrors = [];

        this.show = false;

        axios
          .post(`/products/${this.product.code}/draft-batch-results`, data)
          .then((r) => {
            this.message = 'Draft batch saved';
            this.messageType = 'message message--success';
            this.show = true;
            this.resultsedit = false;
          })
          .catch((e) => {
            this.$Progress.fail();

            if (e.response.data != undefined) {

              var batchErrors = [];

              Validation.parseServerErrors(e.response.data, batchErrors, $scope.genericErrors);
              Validation.updateErrorMessages(batchErrors, $scope.results, $scope.poError, $scope.manualBatchError);

              this.message = 'Unable to save batch records. Please correct validation errors before continuing';
              this.messageType = 'message message--error';
              this.show = true;
            }
          });
      },
      loadFiles() {
        this.$Progress.start();

        let batchno = this.getBatchNo();

        if (batchno != null) {
          batchno = encodeURIComponent(batchno);
        }

        axios
          .get(`/products/${this.product.code}/batches/${batchno}/files`)
          .then((f) => {
            this.internalAttachments = f.data.internalFiles || [];
            this.externalAttachments = f.data.externalFiles || [];

            this.$Progress.finish();
          })
          .catch(() => {
            this.$Progress.fail();
            this.message = 'Results not loaded';
            this.messageType = 'message message--error';
            this.show = true;
          });
      },
      loadBatches() {
        this.message = '';
        this.messageType = '';
        this.show = false;
        this.selectProductEnabled = false;
        this.$Progress.start();

        axios
          .get(`products/${this.product.code}/batches?type[0]=draft&type[1]=live`)
          .then((r) => {
            this.batchesstatus = r.data;
            this.$Progress.finish();
            this.selectProductEnabled = true;
          })
          .catch(() => {
            this.$Progress.fail();
            this.message = 'Batches to not loaded';
            this.messageType = 'message message--error';
            this.show = true;
            this.selectProductEnabled = true;
          });
      },
      getBatchNo() {
        return this.manualbatch ? this.manualbatchno : this.batch;
      },
      getUniqueKey(prefix, value) {
        return `${prefix}_${value}`;
      },
    },
  };
</script>
